module.exports = __webpack_public_path__ + "assets/img/first_transition.7ebb71a5.png";